import React, { useEffect } from "react";

/*eslint-disable */

interface ModalComunidadHyundaiComponentProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalComunidadHyundaiComponent: React.FC<
  ModalComunidadHyundaiComponentProps
> = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      // Bloquear scroll al abrir el modal
      document.body.style.overflow = "hidden";
    } else {
      // Desbloquear scroll al cerrar el modal
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null; // No renderizar si el modal está cerrado

  return (
    <div className="modal-comunidad-hyundai-overlay">
      <div className="modal-comunidad-hyundai-content">
        {children}
        <div>
          <div onClick={onClose} className="close-button-comunidad-hyundai">
            <img src="../assets/01_Home/Close.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalComunidadHyundaiComponent;
